import { map, tap } from 'rxjs';
import { CrudServiceBase, TypeUtils } from '@utils';
import { httpService } from '@services/http';
import { logger } from '@services/logger';
import { AssesmentQuestionService } from './assesment-question.service';
import { Assesment } from './assesment.class';

export class AssementService extends CrudServiceBase<Assesment> {
	constructor() {
		super(Assesment, 'assesment');
	}

	latest() {
		return httpService.get<Assesment>(this.getUrl(), `latest`).pipe(
			map((entity) => TypeUtils.convert(Assesment, entity)),
			tap((result) => logger.debug(`[${this.constructor.name}.${this.get.name}]`, result))
		);
	}

	question(assesmentId: string) {
		return new AssesmentQuestionService(assesmentId);
	}
}

export const assementService = new AssementService();
